import { clients } from '@/lib/https';

const AUTH_API_BASE_URL = import.meta.env.VITE_AUTH_API_BASE_URL?.replace(/\/$/, '') ?? '';

export const getAuthApiUrl = (path: string): string => {
  if (!AUTH_API_BASE_URL) {
    throw new Error('VITE_AUTH_API_BASE_URL is not configured');
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  if (AUTH_API_BASE_URL.startsWith('http')) {
    return `${AUTH_API_BASE_URL}${normalizedPath}`;
  }

  const basePath = AUTH_API_BASE_URL.startsWith('/')
    ? AUTH_API_BASE_URL
    : `/${AUTH_API_BASE_URL}`;

  return `${window.location.origin}${basePath}${normalizedPath}`;
};

export const authApiPost = async <T>(path: string, body: unknown): Promise<T> => {
  return clients.post<T>(getAuthApiUrl(path), JSON.stringify(body ?? {}));
};
